import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const ProductCard = ({ product }) => {
  const { language } = useLanguage();
  const productName = language === 'tr' ? product.name_tr : product.name;

  return (
    <div className="group cursor-pointer">
      <div className="relative aspect-square overflow-hidden bg-gray-100 mb-4">
        <img
          src={product.image}
          alt={productName}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <div className="space-y-1">
        <p className="text-xs text-gray-500 uppercase tracking-wider">{product.brand}</p>
        <h3 className="text-sm text-gray-900 font-medium">{productName}</h3>

      </div>
    </div>
  );
};

export default ProductCard;